module.exports = __webpack_public_path__ + "img/lit_clean_bg.d0983fa0.png";